/** 
*@author: Sirisha.M
*@Description : 
**/
import React, { useState } from 'react';
import { Tabs } from 'antd';
import { connect } from 'react-redux';
import Parameter from '../Masters/Parameter';
import Attributes from '../Masters/Attributes';
import SubEquipments from '../Masters/SubEquipments';
import { StyledHomepage } from '../../../commons/styles/layout';

const DeviceTypes = (props) => {
  const [presentActiveKey, setPresentActiveKey] = useState('SubEquipments');

  const translation = (keyword) => {
    const { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  let searchParams = new URLSearchParams(props.location.search);
  let newParams = Object.fromEntries([...searchParams]);

  const items = [
    {
      key: "SubEquipments",
      label: translation('SubEquipments'),
      children: <SubEquipments {...props} />,
    },
    {
      key: "Parameter",
      label: translation('Parameter'),
      children: <Parameter {...props} type={newParams.type} />,
    },
    {
      key: "Attributes",
      label: translation('Attributes'),
      children: <Attributes {...props} type={newParams.type} />,
    },
  ];

  return (
    <StyledHomepage>
      <Tabs
        tabPosition="top"
        type="card"
        defaultActiveKey="Parameter"
        activeKey={presentActiveKey}
        onChange={(activeKey) => {
          setPresentActiveKey(activeKey || 'SubEquipments');
        }}
        items={items}
      />
    </StyledHomepage>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(DeviceTypes);
